import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const RegisterDetailsPage = () => {
    const navigate = useNavigate();
    const fileInputRef = useRef();

    const [avatarFile, setAvatarFile] = useState(null);
    const [avatarUploading, setAvatarUploading] = useState(false);

    const [dropzone, setHomeDz] = useState("");
    const [currentCanopy, setMainCanopy] = useState("");

    const wrapperStyle = {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        backgroundImage: "url('/background.jpg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        padding: "20px",
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    };

    const formStyle = {
        backgroundColor: "rgba(0,0,0,0.85)",
        padding: "40px 30px",
        borderRadius: "16px",
        maxWidth: "420px",
        width: "100%",
        boxShadow: "0 8px 30px rgba(0,0,0,0.85)",
        color: "#fff",
        boxSizing: "border-box",
    };

    const inputStyle = {
        width: "100%",
        padding: "10px 12px",
        borderRadius: "10px",
        border: "1.5px solid #444",
        backgroundColor: "#1a1a1a",
        color: "#eee",
        fontSize: "15px",
        boxShadow: "inset 0 0 6px #000000cc",
        outline: "none",
        boxSizing: "border-box",
        marginBottom: "15px",
    };

    const [dropzones, setDropzones] = useState([]);
    const [filteredDropzones, setFilteredDropzones] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        const fetchDropzones = async () => {
            try {
                const res = await fetch("/api/dropzones");
                const data = await res.json();
                setDropzones(data);
            } catch (e) {
                console.error(e);
            }
        };

        fetchDropzones();
    }, []);

    const handleDropzoneSearch = (value) => {
        setHomeDz(value);
        setSelectedDropzone(null); // ❗ сброс выбора

        const filtered = dropzones.filter((dz) =>
            (dz.name || "").toLowerCase().includes(value.toLowerCase()) ||
            (dz.city || "").toLowerCase().includes(value.toLowerCase()) ||
            (dz.country || "").toLowerCase().includes(value.toLowerCase())
        );

        setFilteredDropzones(filtered);
        setShowDropdown(true);
    };

    const selectDropzone = (dz) => {
        setHomeDz(dz.name);
        setSelectedDropzone(dz); // ✅ теперь выбрана
        setShowDropdown(false);
    };
    const [selectedDropzone, setSelectedDropzone] = useState(null);


    useEffect(() => {
        const handleClickOutside = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setShowDropdown(false);
            }
        };

        document.addEventListener("click", handleClickOutside);
        return () => document.removeEventListener("click", handleClickOutside);
    }, []);

    const handleSubmit = async () => {
        const baseData = JSON.parse(localStorage.getItem("registerData"));

        if (!baseData) {
            navigate("/register");
            return;
        }

        const formData = new FormData();

        // ✅ Основные данные
        formData.append("login", baseData.login);
        formData.append("fullname", baseData.fullname);
        formData.append("password", baseData.password);
        formData.append("email", baseData.email);
        
        if (dropzone && !selectedDropzone) {
            alert("Выберите дропзону из списка");
            return;
        }
        // ✅ Дополнительные (опционально)
        if (dropzone) formData.append("dropzone", dropzone);
        if (currentCanopy) formData.append("currentCanopy", currentCanopy);

        // ✅ Аватар (опционально)
        if (avatarFile) {
            formData.append("avatar", avatarFile);
        }

        try {
            const res = await fetch("/api/auth/signup", {
                method: "POST",
                body: formData,
            });

            if (!res.ok) {
                const text = await res.text();
                alert(text || "Ошибка регистрации");
                return;
            }

            localStorage.removeItem("registerData");

            alert("Регистрация успешна!");
            navigate("/login");

        } catch (e) {
            console.error(e);
            alert("Ошибка соединения");
        }
    };

    return (
        <div style={wrapperStyle}>
            <div style={formStyle}>
                <h2 style={{ textAlign: "center", marginBottom: "20px" }}>
                    👤 Расскажите о себе
                </h2>

                {/* 💡 ОБЪЯСНЕНИЕ */}
                <div
                    style={{
                        background: "rgba(255,255,255,0.05)",
                        padding: "12px",
                        borderRadius: "10px",
                        marginBottom: "20px",
                        fontSize: "14px",
                        lineHeight: "1.5",
                        color: "#D1D5DB",
                    }}
                >
                    Эти данные не являются обязательными, но помогут вам:
                    <ul style={{ marginTop: "8px", paddingLeft: "18px" }}>
                        <li>находить друзей по дропзонам</li>
                        <li>делиться своим опытом</li>
                        <li>быстрее заполнить профиль</li>
                    </ul>
                </div>

                {/* 🖼 АВАТАР */}
                <div style={{ marginBottom: "20px" }}>
                    <input
                        type="file"
                        accept="image/*"
                        ref={fileInputRef}
                        style={{ display: "none" }}
                        onChange={(e) => setAvatarFile(e.target.files[0])}
                    />

                    <button
                        onClick={() => fileInputRef.current.click()}
                        style={{
                            padding: "10px",
                            borderRadius: "8px",
                            border: "1px solid rgba(255,255,255,0.2)",
                            backgroundColor: "rgba(31, 41, 55, 0.9)",
                            color: "#F3F4F6",
                            cursor: "pointer",
                            width: "100%",
                            marginBottom: "6px",
                        }}
                    >
                        🖼 Выбрать аватар
                    </button>

                    {avatarFile && (
                        <div style={{ fontSize: "13px", opacity: 0.85 }}>
                            Выбран файл: <strong>{avatarFile.name}</strong>
                        </div>
                    )}
                </div>

                {/* 📍 ДРОПЗОНА */}
                <div style={{ position: "relative", marginBottom: "15px" }} ref={dropdownRef}>
                    <input
                        type="text"
                        value={dropzone}
                        placeholder="Домашняя дропзона"
                        onChange={(e) => handleDropzoneSearch(e.target.value)}
                        onFocus={() => setShowDropdown(true)}
                        style={inputStyle}
                    />

                    {showDropdown && (
                        <div
                            style={{
                                position: "absolute",
                                top: "100%",
                                left: 0,
                                right: 0,
                                background: "#111827",
                                borderRadius: "8px",
                                marginTop: "4px",
                                maxHeight: "180px",
                                overflowY: "auto",
                                zIndex: 1000,
                                boxShadow: "0 8px 20px rgba(0,0,0,0.5)"
                            }}
                        >
                            {(dropzone.trim() === "" ? dropzones : filteredDropzones).map((dz, i) => (
                                <div
                                    key={i}
                                    onClick={() => selectDropzone(dz)}
                                    style={{
                                        padding: "10px",
                                        cursor: "pointer",
                                        borderBottom: "1px solid #1F2937"
                                    }}
                                    onMouseEnter={(e) => e.currentTarget.style.background = "#1F2937"}
                                    onMouseLeave={(e) => e.currentTarget.style.background = "transparent"}
                                >
                                    {dz.name} ({dz.city}, {dz.country})
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                {/* 🪂 ПАРАШЮТ */}
                <input
                    placeholder="Основной парашют"
                    value={currentCanopy}
                    onChange={(e) => setMainCanopy(e.target.value)}
                    style={inputStyle}
                />

                {/* 🚀 КНОПКА */}
                <button
                    onClick={handleSubmit}
                    style={{
                        width: "100%",
                        backgroundColor: "#FFD700",
                        color: "#000",
                        padding: "14px",
                        fontSize: "16px",
                        fontWeight: "bold",
                        border: "none",
                        borderRadius: "8px",
                        cursor: "pointer",
                        marginTop: "10px",
                    }}
                >
                    Зарегистрироваться
                </button>
                <button
                    onClick={() => navigate("/signup")}
                    style={{
                        width: "100%",
                        backgroundColor: "#374151",
                        color: "#fff",
                        padding: "12px",
                        fontSize: "15px",
                        border: "none",
                        borderRadius: "8px",
                        cursor: "pointer",
                        marginTop: "10px",
                    }}
                >
                    ⬅️ Назад
                </button>
            </div>
        </div>
    );
};

export default RegisterDetailsPage;